import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import React, { useCallback, useState } from 'react'
import context from '@/context'
import { actionButtonsColumnProps, BsrsGrid, Column, createEnumCellStatus, DateTimeCell, DateTimeFilterCell, EnumFilterCell } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import { ChangeRequest } from './changeRequest'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { useSignalR } from '@/hooks/useSignalR'

function ChangeRequests () {
  const { localize } = useLocalization()
  const [ refreshTime, setRefreshTime ] = useState(new Date())
  const [ chrReloadCount, setChrReloadCount ] = useState(0)
  const [ submitting, setSubmitting ] = useState({})
  const [ canceling, setCanceling ] = useState({})
  const [ merging, setMerging ] = useState({})
  const isGranted = usePermissionChecker()

  // reload CHR draft if data has changed
  useSignalR('reloadChangeRequestList', () => setChrReloadCount(reloadCount => reloadCount + 1), [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const changeRequestDraftDatasource = useCallback(() => context.api.changeRequestService.getChangeRequestDraft(), [chrReloadCount, refreshTime])

  function onSubmitChangeRequest (changeRequestId) {
    setSubmitting({ ...submitting, [changeRequestId]: true })
    context.api.changeRequestService.submitChangeRequest(changeRequestId, { allowErrorDialog: true })
      .then(() => {
        setRefreshTime(new Date())
        setSubmitting({ ...submitting, [changeRequestId]: false })
      })
      .catch(() => setSubmitting({ ...submitting, [changeRequestId]: false }))
  }
  function onCancelChangeRequest (changeRequestId) {
    setCanceling({ ...canceling, [changeRequestId]: true })
    context.api.changeRequestService.cancelChangeRequest(changeRequestId, { allowErrorDialog: true })
      .then(() => {
        setRefreshTime(new Date())
        setCanceling({ ...canceling, [changeRequestId]: false })
      })
      .catch(() => setCanceling({ ...canceling, [changeRequestId]: false }))
  }
  function onMergeChangeRequest (changeRequestId) {
    setMerging({ ...merging, [changeRequestId]: true })
    context.api.changeRequestService.mergeWithDraft(changeRequestId, { allowErrorDialog: true })
      .then(() => {
        setChrReloadCount(chrReloadCount + 1)
        setMerging({ ...merging, [changeRequestId]: false })
      })
      .catch(() => setMerging({ ...merging, [changeRequestId]: false }))
  }
  const enumName = 'ChangeRequestStatus'
  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          {localize('Tasks.ChangeRequests')}
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <ChangeRequest reloadCount={chrReloadCount} isDraft dataSource={changeRequestDraftDatasource}
          onChangeRequestCreated={() => setRefreshTime(new Date())} />
        <WhiteBox header='Menu.ChangeRequests'>
          <BsrsGrid persistenceId={'change-requests'} key={refreshTime} dataSource={context.api.changeRequestService.getChangeRequests} defaultSort={[{ field: 'lastModificationTime', dir: 'desc' }]}>
            <Column field='id' title={localize('Common.Id')} width='100px' filter='numeric' />
            <Column field='internalTicketIdsText' title={localize('Common.InternalTicketIDs')} width='150px' filterable={false} sortable={false} />
            <Column field='creationTime' title={localize('Common.CreationTime')} cell={DateTimeCell} filterCell={DateTimeFilterCell} />
            <Column field='creatorUserName' title={localize('Common.Creator')} />
            <Column field='lastModificationTime' title={localize('Common.LastModificationTime')} cell={DateTimeCell} filterCell={DateTimeFilterCell} />
            <Column field='status' title={localize('Common.Status')}
              cell={createEnumCellStatus({ enumName, visualStatus: [4, 2, 3, 1, 0, 3] })}
              filterCell={EnumFilterCell({ localize, enumName }, [4, 2, 3, 1, 0, 3])} enumName={enumName} />
            <Column {...actionButtonsColumnProps(item => [
              (item.status === 3 && isGranted('CanSubmitChangeRequests')) ? { onClick: x => onSubmitChangeRequest(x.id), title: localize('Common.SendToCBI'), icon: submitting[item.id] ? 'loader bx-spin' : 'send', disabled: submitting[item.id] } : null,
              item.status === 3 ? { onClick: x => onCancelChangeRequest(x.id), title: localize('Common.RejectChangeRequest'), icon: canceling[item.id] ? 'loader bx-spin' : 'block', disabled: canceling[item.id] } : null,
              { onClick: x => onMergeChangeRequest(x.id), title: localize('Common.MergeChangesIntoDraft'), icon: merging[item.id] ? 'loader bx-spin' : 'git-pull-request', disabled: merging[item.id] },
              { url: `/demographics/change-requests/${item.id}`, title: localize('Common.Details'), icon: 'show' }
            ].filter(Boolean))} />
          </BsrsGrid>
        </WhiteBox>
      </MainBody>
    </Main>
  )
}

export {
  ChangeRequests
}



// WEBPACK FOOTER //
// ./src/report-app/pages/changeRequests/index.js